/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultTemplateFolder } from '../../models/api-response-paged-result-template-folder';
import { PagedRequestTemplateFolder } from '../../models/paged-request-template-folder';

export interface SearchTemplateFolder$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestTemplateFolder
}

export function searchTemplateFolder(http: HttpClient, rootUrl: string, params: SearchTemplateFolder$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultTemplateFolder>> {
  const rb = new RequestBuilder(rootUrl, searchTemplateFolder.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultTemplateFolder>;
    })
  );
}

searchTemplateFolder.PATH = '/v1/api/ui/templateFolder/search';
